// src/pages/Dashboard.jsx
import React from 'react';
import styled from 'styled-components';
import Header from '../components/Header';
import VeilleDashboard from '../components/VeilleDashboard';

const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Content = styled.main`
  flex-grow: 1;
  padding: 2rem;
`;

const DashboardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`;

const TitleSection = styled.div``;

const Dashboard = () => {
  return (
    <PageContainer>
      <Header />
      <Content>
        <DashboardHeader>
          <TitleSection>
            <h1>Tableau de bord des veilles</h1>
            <p>Gérez les veilles actives et leurs paramètres.</p>
          </TitleSection>
        </DashboardHeader>
        
        <VeilleDashboard />
      </Content>
    </PageContainer>
  );
};

export default Dashboard;